import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaginationFeaturesDto } from '../models/paginationfeaturesdto';
import { GeneralDiscountCatalogDto } from '../models/discountGeneralCatalog/GeneralDiscountCatalogDto.model';
import { DiscountAssociationsControlTypesDto } from '../models/discountGeneralCatalog/DiscountAssociationsControlTypesDto.model';
import { DiscountControlCheckValueDto } from '../models/discountGeneralCatalog/DiscountControlCheckValue.model';
import { IdOwnRateDiscountDto } from '../models/discountGeneralCatalog/OwnRateDiscount.modelDto';
import { DiscountRateModelCatalogDto } from '../models/discountGeneralCatalog/DiscountRateModelCatalog.model';
import { AppConfigService } from './core/appConfig.service';


@Injectable({
    providedIn: 'root'
})
export class DiscountService {

    constructor(private http: HttpClient, private configService: AppConfigService) { }

    getListGeneralDiscountCatalog(pageRequest: PaginationFeaturesDto): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', pageRequest.sizePage)
            .set('orderField', 'discountCode')
            .set('order', pageRequest.order);
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/general-discount/getAll?${params}`).pipe(
            map(response => { return response; }));
    }

    getListGeneralDiscountCatalogById(id?: number): Observable<any> {
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/general-discount/filter/` + id).pipe(
            map(response => { return response; }));
    }

    insertGeneralDiscountCatalog(generalDiscount: GeneralDiscountCatalogDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/general-discount/insert`;
        return this.http.post<any>(url, generalDiscount).pipe(
            map(response => {
                return new GeneralDiscountCatalogDto(response);
            })
        );
    }

    updateGeneralDiscountCatalog(vatPattern: GeneralDiscountCatalogDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/general-discount/update/true`;
        return this.http.put<any>(url, vatPattern).pipe(
            map(response => {
                return new GeneralDiscountCatalogDto(response);
            })
        );
    }

    updateActiveOrDisableGeneralDiscount(vatPattern: GeneralDiscountCatalogDto, active: string, idGeneralDiscountCatalog: number): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/general-discount/activeOrDisable/` + idGeneralDiscountCatalog + `/` + active;
        return this.http.put<any>(url, vatPattern).pipe(
            map(response => {
                return new GeneralDiscountCatalogDto(response);
            })
        );
    }

    //AssociationsControlTypes

    getListAssociationsControlTypes(pageRequest: PaginationFeaturesDto): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', 100)
            .set('orderField', 'discountCode')
            .set('order', pageRequest.order);
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/general-discount/getAll/associations/discount-control-types?${params}`).pipe(
            map(response => { return response; }));
    }

    insertAssociationsControlTypes(generalDiscount: DiscountAssociationsControlTypesDto, idGeneralDiscountCatalog: number | undefined, idDiscountControlType: number | undefined): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/general-discount/insert/association/general-discount/` + idGeneralDiscountCatalog + `/control-type/` + idDiscountControlType;
        return this.http.post<any>(url, generalDiscount).pipe(
            map(response => {
                return new DiscountAssociationsControlTypesDto(response);
            })
        );
    }

    updateAssociationsControlTypes(generalDiscount: DiscountAssociationsControlTypesDto, idGeneralDiscountCatalog: number | undefined, idDiscountControlType: number | undefined): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/general-discount/update/association/general-discount/` + idGeneralDiscountCatalog + `/control-type/` + idDiscountControlType;
        return this.http.put<any>(url, generalDiscount).pipe(
            map(response => {
                return new DiscountAssociationsControlTypesDto(response);
            })
        );
    }

    //OwnRateDiscount

    getListOwnRateDiscount(pageRequest: PaginationFeaturesDto): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', 100)
            .set('orderField', 'idOwnRateDiscount')
            .set('order', pageRequest.order)
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/own-rate-discount/listAll?${params}`).pipe(
            map(response => { return response; }));
    }

    loadOwnRateDiscountByRateType(pageRequest: PaginationFeaturesDto, idRate: number, rateType: string): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', 100)
            .set('orderField', 'startDate')
            .set('order', pageRequest.order)
            .set('idRate', idRate)
            .set('rateType', rateType)
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/own-rate-discount/listAll?${params}`).pipe(
            map(response => { return response; }));
    }

    insertOwnRateDiscount(generalDiscount: IdOwnRateDiscountDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/own-rate-discount/insert`;
        return this.http.post<any>(url, generalDiscount).pipe(
            map(response => {
                return new IdOwnRateDiscountDto(response);
            })
        );
    }

    updateOwnRateDiscount(generalDiscount: IdOwnRateDiscountDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/own-rate-discount/update`;
        return this.http.put<any>(url, generalDiscount).pipe(
            map(response => {
                return new IdOwnRateDiscountDto(response);
            })
        );
    }

    //DiscountRateModelCatalo

    getListDiscountRateModelCatalog(pageRequest: PaginationFeaturesDto, idRateModel: any): Observable<any> {
        const params = new HttpParams()
            .set('idRateModel', idRateModel)
            .set('page', pageRequest.page)
            .set('sizePage', pageRequest.sizePage)
            .set('orderField', '')
            .set('order', pageRequest.order)
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/rate-model/discount/getAll?${params}`).pipe(
            map(response => { return response; }));
    }

    insertDiscountRateModelCatalog(generalDiscount: DiscountRateModelCatalogDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/rate-model/discount/insert`;
        return this.http.post<any>(url, generalDiscount).pipe(
            map(response => {
                return new DiscountRateModelCatalogDto(response);
            })
        );
    }

    updateDiscountRateModelCatalog(generalDiscount: DiscountRateModelCatalogDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/rate-model/discount/update`;
        return this.http.put<any>(url, generalDiscount).pipe(
            map(response => {
                return new DiscountRateModelCatalogDto(response);
            })
        );
    }

    //DiscountRateModelControlTypeCatalog

    getListDiscountRateModelControlTypeCatalog(pageRequest: PaginationFeaturesDto, idRateModel: any, idDiscount: any): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', 100)
            .set('orderField', '')
            .set('order', pageRequest.order)
            .set('idRateModel', idRateModel)
            .set('idGeneralDiscountCatalog', idDiscount)
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/discount-validation-rate-model-type/getAll?${params}`).pipe(
            map(response => { return response; }));
    }

    insertDiscountRateModelControlTypeCatalog(generalDiscount: any): Observable<any> {
        let body = {
            alphanumericValue: generalDiscount.discountValidationRateModelWithControlTypeDto?.alphanumericValue || null,
            numericValue: generalDiscount.discountValidationRateModelWithControlTypeDto?.numericValue || null,
            decimalValue: generalDiscount.discountValidationRateModelWithControlTypeDto?.decimalValue || null,
            valueStartDate: generalDiscount.discountValidationRateModelWithControlTypeDto?.valueStartDate || null,
            valueEndDate: generalDiscount.discountValidationRateModelWithControlTypeDto?.valueEndDate || null,
            rateModelId: generalDiscount.discountModelRateControlTypePkDto?.rateModelId,
            discountControlTypeId: generalDiscount.discountModelRateControlTypePkDto?.discountControlTypeId,
            generalDiscountCatalogId: generalDiscount.discountModelRateControlTypePkDto?.generalDiscountCatalogId
        }
        const url = `${this.configService.apiUrl}/configuration/discount-validation-rate-model-type/insert`;
        return this.http.post<any>(url, body).pipe(
            map(response => {
                return response;
            })
        );
    }

    updateDiscountRateModelControlTypeCatalog(generalDiscount: any): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/discount-model-rate-control-type/update`;
        return this.http.put<any>(url, generalDiscount).pipe(
            map(response => {
                return new DiscountRateModelCatalogDto(response);
            })
        );
    }

    deleteDiscountRateModelControlTypeCatalog(idDiscountValidationRateModelWithControl: any): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/discount-validation-rate-model-type/delete/` + idDiscountValidationRateModelWithControl;
        return this.http.delete<any>(url).pipe(
            map(response => {

            })
        );
    }

    //DiscountRateModelValidations

    getListDiscountRateModelValidations(pageRequest: PaginationFeaturesDto): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', 100)
            .set('orderField', '')
            .set('order', pageRequest.order);
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/discount-validation-rate-model-type/getAll?${params}`).pipe(
            map(response => { return response; }));
    }

    insertDiscountRateModelValidations(generalDiscount: DiscountRateModelCatalogDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/discount-validation-rate-model-type/insert`;
        return this.http.post<any>(url, generalDiscount).pipe(
            map(response => {
                return new DiscountRateModelCatalogDto(response);
            })
        );
    }

    updateDiscountRateModelValidations(generalDiscount: DiscountRateModelCatalogDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/discount-validation-rate-model-type/update`;
        return this.http.put<any>(url, generalDiscount).pipe(
            map(response => {
                return new DiscountRateModelCatalogDto(response);
            })
        );
    }

    //DiscountControlType

    getListDiscountControlType(pageRequest: PaginationFeaturesDto): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', pageRequest.sizePage)
            .set('orderField', 'description')
            .set('order', pageRequest.order);
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/discount-control/type/listAll?${params}`).pipe(
            map(response => { return response; }));
    }

    //DiscountControlCheckValue

    getListDiscountControlCheckValue(pageRequest: PaginationFeaturesDto): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', pageRequest.sizePage)
            .set('orderField', 'idDiscountControlCheckValues')
            .set('order', pageRequest.order);
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/discount-control/check-value/listAll?${params}`).pipe(
            map(response => { return response; }));
    }

    getListDiscountControlCheckValueById(id?: number): Observable<any> {
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/discount-control/check-value/filter/` + id).pipe(
            map(response => { return response; }));
    }

    insertDiscountControlCheckValue(generalDiscount: DiscountControlCheckValueDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/discount-control/check-value/insert`;
        return this.http.post<any>(url, generalDiscount).pipe(
            map(response => {
                return new DiscountControlCheckValueDto(response);
            })
        );
    }

    updateDiscountControlCheckValue(generalDiscount: DiscountControlCheckValueDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/discount-control/check-value/update`;
        return this.http.put<any>(url, generalDiscount).pipe(
            map(response => {
                return new DiscountControlCheckValueDto(response);
            })
        );
    }
}